import './styles/main.css';
import { FormApp } from './form-app';
import { ManagementApp } from './management-app';

if (window.location.pathname.startsWith('/management')) new ManagementApp().start();
else new FormApp().start();
